import { useAuth } from '../../hooks/useAuth';

/**
 * Fixed banner shown while viewing the app as another user (read-only
 * impersonation session). The server rejects all mutating requests for this
 * session; the banner makes the mode obvious and offers the only exit.
 */
const ImpersonationBanner = () => {
  const { impersonating, user, stopImpersonation } = useAuth();

  if (!impersonating) return null;

  return (
    <div className='fixed bottom-0 inset-x-0 z-[100] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-semibold text-black shadow-lg'>
      <span>
        กำลังดูในมุมมองของ {user?.full_name ?? 'ผู้ใช้อื่น'} (อ่านอย่างเดียว)
      </span>
      <button
        type='button'
        onClick={() => void stopImpersonation()}
        className='rounded bg-black px-3 py-1 text-xs font-bold text-white hover:bg-gray-800'
      >
        ออกจากมุมมองนี้
      </button>
    </div>
  );
};

export default ImpersonationBanner;
